var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-icon',{staticClass:"m-mobile-navigation-button",attrs:{"icon":_vm.isActive ? 'close' : 'menu'},nativeOn:{"click":function($event){return _vm.toggleMenu.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }